import { BorderProps } from './types';

export const border: BorderProps = { borderColor: 'border', borderStyle: 'solid', borderWidth: 'sm' };
